


































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { Prop } from 'vue-property-decorator';
import  { MswApiService } from '@/shared/msw-api-service';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'review-affiliation';
@Component({
  components: {
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    assignedUsers: { required },
  },
})
export default class ReviewAffiliation extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showReviewAffiliation: boolean;

  @Prop()
  customerName: any;

  @Prop()
  id: any;

  assignedUsers: string[] = [];
  usersOptions: SelectOption[] = [];

  usersForAffiliation() {
    this.$store.commit('startLoading');
    MswApiService.affiliations.getUsersForAffiliation()
    .then((resp: any) => {
      console.warn(resp);
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
        resp?.content?.availbleUsers.forEach((ele: any) => {
          const obj = {
            id: ele.partyId,
            value: ele.emailAddress,
            label: ele.fullName,
          };
          this.usersOptions.push(obj);
        });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc || 'Something Went Wrong' });
        this.closeDialog();
      }
    });
  }

  created() {
    this.usersForAffiliation();
  }

  checkInputValidation(): boolean {
    this.$v!.assignedUsers!.$touch();
    if (this.assignedUsers.length !== 0) {
      return true;
    }
    return false;
  }

  submit() {
    console.warn(this.checkInputValidation());
    if (!this.checkInputValidation()) {
      return;
    }
    const usersPayload = this.assignedUsers.map((ele: any) => {
      return {
        partyId: ele,
      };
    });
    const req = {
      affiliationID: this.id,
      assignedusers: usersPayload,
      mode: 'accept',
    };
    this.$store.commit('startLoading');
    MswApiService.affiliations.reviewAffiliation(req)
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        this.closeDialog(true);
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    })
    .catch((err:any) => {
      console.error(err);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  closeDialog(val: boolean = false) {
    this.$emit('closeReviewAff', val);
  }

}
